import type { SuggestionKeyDownProps } from '@tiptap/suggestion'

import type { TextVariableDto } from '@/entities/variables/model/dtos'
import { TiptapSuggestionsConfig } from '@/entities/tiptap-suggestions'

export const VARIABLENODE_NAME = 'rsVariableNode' as const
export const VARIABLENODE_TAG = 'rs-variable' as const

/** @deprecated We're migrating from `<variable data-type="variable" [...] />` to `<rs-variable [...] />` */
export const VARIABLENODE_TAG_LEGACY = 'variable' as const

export const variablesExtensionConfig = new TiptapSuggestionsConfig({
  name: VARIABLENODE_NAME,
  nodeTag: VARIABLENODE_TAG,
  character: '$',
  supportedNavigationKeys: ['ArrowUp', 'ArrowDown', 'Enter'],
})

export type VariablesSuggestionsCommandReturn = {
  variable: TextVariableDto
}

export interface VariablesSuggestionsHandle {
  onKeyDown: (props: SuggestionKeyDownProps) => boolean
}
